import { render, staticRenderFns } from "./inputCurrency.vue?vue&type=template&id=31772594"
import script from "./inputCurrency.vue?vue&type=script&lang=js"
export * from "./inputCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports